// extracted by mini-css-extract-plugin
export default {"filterIcon":"ContactsMain_filterIcon__qhTqg","add-icon":"ContactsMain_add-icon__ItuYy","icon-24":"ContactsMain_icon-24__v4kRz"};